import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateRefundDetailsAction as updateRefundDetails } from '../../../../../services/RefundService/slice';

export const RefundReasonField: React.FC = () => {
    const dispatch = useAppDispatch();
    const { currentRefund } = useAppSelector(state => state.refund);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(updateRefundDetails({ reason: event.target.value }));
    };

    return (
        <TextField
            label="Reason"
            value={currentRefund?.refundDetail?.reason || ''}
            onChange={handleChange}
            size="small"
            fullWidth
        />
    );
};

export default RefundReasonField;
